"use client";

import Link from "next/link";

import { ArrowLeft, Mail, MapPin, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

import { CONTACT_INFO, CONTACT_LINKS } from "@/shared/config/contact";
import { LandingFooter } from "@/widgets/landing/ui/landing-footer";
import { LandingHeader } from "@/widgets/landing/ui/landing-header";

const SECTION_KEYS = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10"] as const;

export function PrivacyPageClient() {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen scroll-smooth bg-white text-slate-900 antialiased">
      <LandingHeader />
      <main className="px-6 py-16 sm:py-24">
        <article className="mx-auto max-w-3xl">
          <Link
            href="/"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-teal-600 transition-colors hover:text-teal-700"
          >
            <ArrowLeft className="size-4" />
            {t("landing.privacy.backHome")}
          </Link>

          <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            {t("landing.privacy.title")}
          </h1>
          <p className="mt-3 text-sm text-slate-500">{t("landing.privacy.lastUpdated")}</p>

          <p className="mt-8 text-base leading-relaxed text-slate-600">{t("landing.privacy.intro")}</p>

          <div className="mt-10 flex flex-col gap-8">
            {SECTION_KEYS.map((key) => (
              <section key={key}>
                <h2 className="text-lg font-semibold text-slate-900 sm:text-xl">{t(`landing.privacy.${key}Title`)}</h2>
                <p className="mt-2 text-base leading-relaxed text-slate-600">{t(`landing.privacy.${key}Body`)}</p>
                {key === "s10" ? (
                  <ul className="mt-4 flex flex-col gap-2">
                    <li>
                      <a
                        href={CONTACT_LINKS.email}
                        className="flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-teal-600"
                      >
                        <Mail className="size-4 text-slate-400" />
                        {CONTACT_INFO.email}
                      </a>
                    </li>
                    <li>
                      <a
                        href={CONTACT_LINKS.phone}
                        className="flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-teal-600"
                      >
                        <Phone className="size-4 text-slate-400" />
                        {CONTACT_INFO.phone}
                      </a>
                    </li>
                    <li>
                      <span className="flex items-center gap-2 text-sm text-slate-600">
                        <MapPin className="size-4 text-slate-400" />
                        {CONTACT_INFO.address}
                      </span>
                    </li>
                  </ul>
                ) : null}
              </section>
            ))}
          </div>
        </article>
      </main>
      <LandingFooter />
    </div>
  );
}
